export default __webpack_public_path__ + "static/media/BurgerClose.3820b097.svg";